import { Box, Card, Grid, Typography } from "@mui/material";
import React from "react";
import noPic from "../assets/no-pic.png";

const CategoreyCard = (props) => {
  const gridMd = props.gridMd || 3;
  const cardHeight = props.cardHeight || { xs: "108px", lg: "160px" };
  return (
    <Grid item xs={4} sm={3} md={gridMd}>
      <Card
        onClick={() => props.handleClick(props.id)}
          sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          height: cardHeight,
          backgroundColor: props.cardBg || undefined,
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.15)",
          cursor: "pointer",
          overflow: "hidden",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
          "&:hover": {
            transform: "scale(1.06)",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.22)",
          },
          "&:active": {
            transform: "scale(0.97)",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.15)",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
            /* Adjust padding for desktop scale */
            padding: { xs: "3.2px 3.2px 3.2px 3.2px", lg: "8px" },
            overflow: "hidden",
          }}
        >
          {/* Image wrapper takes all available space above the text */}
          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              minHeight: 0,
            }}
          >
            <Box
              component="img"
              src={props.image ? props.image : noPic}
              alt={props.title}
              sx={{
                /* Maintain proportional image sizing */
                width: { xs: "calc(82.5% + 20mm)", md: "100%" },
                height: { xs: "82.5%", md: "100%" },
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
          {/* Text always pinned at the bottom */}
          <Typography
            component="p"
            sx={{
              color: props.isGrid ? "#000000" : "#ffffff",
              /* Increased font size for desktop */
              fontSize: { xs: "9.6px", lg: "14px" },
              fontWeight: "500",
              textAlign: "center",
              width: "100%",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: 1.2,
              /* Adjust margin for desktop */
              marginTop: { xs: "1.6px", lg: "6px" },
              flexShrink: 0,
              /* && doubles the CSS class specificity MUI emits,
                 making it beat any !important rule in a stylesheet */
              "&&": {
                color: props.textColor != null ? props.textColor : "rgba(0,0,0,0.6)",
              },
            }}
          >
            {props.title}
          </Typography>
        </div>
      </Card>
    </Grid>
  );
};

export default CategoreyCard;

